import * as React from 'react';
import { LegacyMasonry, Masonry } from '@leagueplatform/masonry';
import { PRODUCT_AREA, SCREEN_NAMES } from '#constants/analytics.ts';
import { useIsMetricsImprovementsEnabled } from '#hooks/use-is-metrics-improvements-enabled.ts';

const MasonryComposer = new LegacyMasonry({
  appId: 'dashboard-metrics',
  apiVersion: 2,
  analytics: {
    productArea: PRODUCT_AREA.DASHBOARD,
    screenName: SCREEN_NAMES.ABOUT_ME_METRICS,
  },
});

export function AllMetricCards() {
  const { isMetricsImprovementsEnabled } = useIsMetricsImprovementsEnabled();

  if (isMetricsImprovementsEnabled) {
    return <Masonry rootNodeId="aboutMeMetrics$root" />;
  }
  return <MasonryComposer.Provider />;
}
